import React from 'react'
import { ClientTypes } from 'types'
import { STORAGE_KEYS, PAGE_TYPES } from 'src/constants'
import { Button, ProductList } from 'components'
import { Order, SelectCustomer } from 'containers'
import { isSalesRep, Gtm } from 'helpers'
import { Link } from 'react-router-dom'
import { BasketTypes } from 'types'
import { ArrowLeftIcon } from 'assets/icons'

import './Basket.scss'

interface Props {
    items: BasketTypes.Item[],
    clearBasket: Function
}

interface State {
    edit: boolean,
    order: boolean,
    submit: boolean,
    selectedClient?: ClientTypes.Client | null
}

export default class Basket extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)
        const getClient = localStorage.getItem(STORAGE_KEYS.CLIENT)
        this.state = {
            edit: false,
            order: false,
            submit: false,
            selectedClient: getClient ? JSON.parse(getClient) : null
        }
    }

    public componentDidMount() {
        document.getElementsByTagName('html')[0].classList.add('page-basket')
        // GTM
        Gtm.pushPageType(PAGE_TYPES.CART)
    }

    public componentWillUnmount() {
        document.getElementsByTagName('html')[0].classList.remove('page-basket')
    }

    public toggleOrder = () => {
        this.setState({
            order: !this.state.order
        })
    }

    public toggleEdit = () => {
        this.setState({
            edit: !this.state.edit
        })
    }

    public selectedClient = (client: ClientTypes.Client) => {
        this.setState({
            order: client !== null,
            submit: true,
            selectedClient: client
        })
    }

    public render() {

        const { items, clearBasket } = this.props

        return (
            <React.Fragment>
                {this.state.order ?
                    isSalesRep() && !this.state.submit ?
                        <SelectCustomer onSelect={this.selectedClient} />
                    :
                    <Order
                        onCancel={this.toggleOrder}
                        basket={items}
                        clearBasket={clearBasket}
                    />
                    :
                    <section className="page-layout">

                        <header className="u-flex u-flex-between">
                            <Link to="/search" className="button--link u-flex-start">
                                <ArrowLeftIcon fill="#000000"/>
                                Back
                            </Link>
                            {items.length > 0 &&
                                <a
                                    href="#"
                                    className="button--link u-flex-end"
                                    onClick={this.toggleEdit}
                                >
                                    {this.state.edit ? 'Done' : 'Edit'}
                                </a>
                            }
                        </header>
                        <main>
                            <h1 className="u-margin-top--md">Basket</h1>
                            <ProductList items={items} edit={this.state.edit}/>
                        </main>
                        <footer>
                            <Link to="/search" className="text-link u-text--centered">Find more surplus</Link>
                            <Button
                                full={true}
                                disabled={items.length === 0}
                                className="u-margin-top--md"
                                onClick={this.toggleOrder}
                            >Order now
                            </Button>
                        </footer>
                    </section>}
            </React.Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/Basket/index.tsx